import { render, staticRenderFns } from "./JokeCardDetails.vue?vue&type=template&id=02e93e34&scoped=true&"
import script from "./JokeCardDetails.vue?vue&type=script&lang=js&"
export * from "./JokeCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./JokeCardDetails.vue?vue&type=style&index=0&id=02e93e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e93e34",
  null
  
)

export default component.exports